@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.footer {
  padding: @space-24 56px @space-32;
  text-align: center;
  margin-top: auto;
  align-items: center;
}

.title {
  font-size: 14px;
  font-weight: 600;
  color: var(--grey-600);
  line-height: 20px;
}

.description {
  font-size: 12px;
  font-weight: 400;
  color: var(--grey-600);
  line-height: 16px;
}
